module.exports = __webpack_public_path__ + "img/front_neck_depth.93b6a151.png";